angular.module('zc.core')
  .directive('peTrack', peTrack);

peTrack.$inject = ['ZcTag'];
function peTrack(ZcTag) {
  return {
    restrict: 'A',
    link: link,
    scope: {
      peAttrs: '<'
    }
  };

  function link(scope, elem, attrs) {
    const minimumDuration = 500;
    let clickCount = 0;

    let t = new Date().valueOf();
    const mouseEnter = e => {
      t = new Date().valueOf();
    };
    const mouseLeave = () => {
      const duration = new Date().valueOf() - t;
      if(duration > minimumDuration) {
        const attribute = _.merge(scope.peAttrs || {}, { duration });
        ZcTag.sendParticularEvent(`${attrs.peTrack}:hover`, attribute);
      }
    };
    elem.mouseenter(mouseEnter).mouseleave(mouseLeave);

    elem.click(function() {
      clickCount++;
      const attribute = _.merge(scope.peAttrs || {}, { click_count: clickCount });

      ZcTag.sendParticularEvent(`${attrs.peTrack}:click`, attribute);
    });
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/pe_track.directive.js